import { Button } from 'primereact/button';
import { useLanguageContext } from '../../contexts/LanguageContext';

export default function LanguageManagerGuard({ children, isCreation }) {
  const { currentLanguage, setLanguageContext } = useLanguageContext();
  if (isCreation && currentLanguage.code !== 'fr') {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center">
        <p className="text-slate-800">Cette fonctionnalité est disponible</p>
        <p className="text-slate-800 font-medium">uniquement en français</p>
        <Button
          label="Passer en français"
          className="w-fit mt-5"
          onClick={() => setLanguageContext('fr')}
          icon="fi fi-fr"
          iconPos="right"
        />
      </div>
    );
  }
  return children;
}
